import { render, staticRenderFns } from "./PagesToplistWidget.vue?vue&type=template&id=2ab50cf1&"
import script from "./PagesToplistWidget.vue?vue&type=script&lang=js&"
export * from "./PagesToplistWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports